// @ts-nocheck
import { IconCalendarEvent, IconClock, IconMapPin } from '@tabler/icons-react';
import Time from '@/utils/time';
import styles from './CustomerZoneHome.module.css';
import { MiniCard, MiniRow } from './CustomerZoneShared';

interface Props {
  appointments: any[];
  base: string;
  nav: (path: string) => void;
  limit?: number;
}

export default function CustomerZoneAppointmentsTab({ appointments, base, nav, limit }: Props) {
  if (!appointments.length) return <p className={styles.emptyNote}>There are no appointments</p>;

  const items = limit ? appointments.slice(0, limit) : appointments;
  return items.map((appt, i) => (
    <MiniCard
      key={i}
      href={`/customerzone/viewappointment${base}&i=${appt.ID}`}
      title={appt.Subject || Time.formatDate(appt.StartDateTime)}
      tone="info"
      onClick={() => nav(`/customerzone/viewappointment${base}&i=${appt.ID}`)}
      rows={<>
        <MiniRow icon={<IconCalendarEvent />}>{Time.formatDate(appt.StartDateTime)}</MiniRow>
        <MiniRow icon={<IconClock />}>
          {Time.toISOString(Time.parseDate(appt.StartDateTime), false, true, false, null, false)}
        </MiniRow>
        {appt.Location?.AddressLine1 && (
          <MiniRow icon={<IconMapPin />}>{appt.Location.AddressLine1}</MiniRow>
        )}
      </>}
    />
  ));
}
